import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { label: '身体介護', path: '/services' },
      { label: '生活援助', path: '/services' },
      { label: '通院介助', path: '/services' },
      { label: '料金案内', path: '/services' },
    ],
    company: [
      { label: '会社概要', path: '/about' },
      { label: 'アクセス', path: '/about' },
      { label: '求人情報', path: '/recruit' },
      { label: 'ブログ', path: '/blog' },
    ],
  };

  return (
    <footer className="bg-navy-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 mb-10 sm:mb-12">
          {/* 事業所情報 */}
          <div className="lg:col-span-2">
            <h3 className="text-base sm:text-lg md:text-xl font-bold mb-4 sm:mb-6">
              ヘルパーステーションおかやま
            </h3>
            <div className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-white/90">
              <p className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-0.5 flex-shrink-0 text-base"></i>
                <span>岡山市北区○○町1-2-3</span>
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2 flex-shrink-0 text-base"></i>
                <a href="tel:086-012-3456" className="hover:text-coral-400 transition-colors cursor-pointer">
                  086-012-3456
                </a>
              </p>
              <p className="flex items-center">
                <i className="ri-printer-line mr-2 flex-shrink-0 text-base"></i>
                <span>086-012-3457</span>
              </p>
              <p className="flex items-start">
                <i className="ri-time-line mr-2 mt-0.5 flex-shrink-0 text-base"></i>
                <span>営業時間：9:00 〜 18:00<br />定休日：日曜日・祝日</span>
              </p>
            </div>
          </div>

          {/* サービス */}
          <div>
            <h4 className="text-sm sm:text-base md:text-lg font-bold mb-4 sm:mb-6">
              サービス
            </h4>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-white/90 hover:text-coral-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 会社情報 */}
          <div>
            <h4 className="text-sm sm:text-base md:text-lg font-bold mb-4 sm:mb-6">
              会社情報
            </h4>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-white/90 hover:text-coral-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-6 sm:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs sm:text-sm text-white/70">
          <p className="text-center sm:text-left">
            &copy; {currentYear} ヘルパーステーションおかやま. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-coral-400 transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
